import React, { Fragment } from 'react';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';

import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PeopleIcon from '@material-ui/icons/People';
import NotesIcon from '@material-ui/icons/Notes';
import RefreshIcon from '@material-ui/icons/Refresh';
import ReplyIcon from '@material-ui/icons/Reply';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';
import TodayIcon from '@material-ui/icons/Today';

import qrIcon from '../assets/qrIcon.png'

import { Tooltip, Grid, Typography, Checkbox, Paper, Button, IconButton, Tabs, Tab, TextField } from '@material-ui/core'
import { ManageTextField, ManageDecimalField, ManageNumericField, RichTextEditor, DateUtils, OpenQRPopupWindow } from 'react-frontend-utils'

import { EditPatronPopover } from '../components/EditPatronPopover'
import { PatronSignupTable } from '../components/PatronSignupTable'
import { PatronCheckInTable } from '../components/PatronCheckInTable'
import { PatronQuestionsViewer } from '../components/PatronQuestionsViewer';
import { RefundPopover } from '../components/RefundPopover'
import { RecurrenceSignupQuestionDialog } from '../components/RecurrenceSignupQuestionDialog'
import { EventSigninSheet } from '../components/EventSigninSheet'
import { CommonPatronFunctions } from '../components/CommonPatronFunctions'

import { ThemeColors } from '../Theme'
import { OpenInNewTab } from '../App'

import { Patron } from '../models/Patron';
import { OptionalCost } from '../models/OptionalCost';
import { CalEvent, Signup } from '../models/CalEvent';
import { Global, Constructors } from '../models/Global';
import { Resource } from '../models/Resource';
import { MultiDayEvent } from '../models/MultiDayEvent';

import { AudioPlay } from '../utils/Audio';

import { RestComponent } from 'react-frontend-utils'
import { FormTemplate, FieldEditor, renderField } from 'form-builder';

import { DateConversions } from '../utils/DateConversions';


/**
 * Page that is mounted from the SlotsListPage (for Events) when a user selects to manage signups for an Event. Closing this page will return to the SlotsListPage.
 * The following props are passed to this page:
 * 
 * id: The Event id that we are managing signups for
 * exitCallback: Callback function to call when the page is closed
 * viewSlotInCalendarCallback: Callback function to call when the user wants to view the Event in the Calendar (takes Event obj as parameter and a boolean to edit or not)
 * 
 */
class EventSignupPage extends RestComponent {
  
    styles = {
            paperLabel: {
                marginLeft: 5,
                marginBottom: 30,
                color: 'gray',
            },
            paper: {
                padding: 10,
                marginBottom: 20,
            },
            roundedContainer: {
                border: '1px solid #CCCCCC', 
                borderRadius: '4px', 
                padding: 10,
                marginBottom: 20,
            },
            containerLabel: {
                fontSize: 14, 
                color: ThemeColors.darkGray, 
                marginLeft: 5
            },
            sectionLabel: {
                fontSize: 16, 
                color: 'black', 
                marginLeft: 5
            },
            viewLabel: {
                fontSize: 12, 
                color: 'gray', 
                marginLeft: 5
            },
            checkedInLabel: {
                marginBottom: 30,
                fontWeight: 'bold', 
                backgroundColor: ThemeColors.appBarBackground,
                color: 'white',
                borderRadius: '5px', 
                paddingLeft: 12,
                paddingRight: 12,
            }

        };
   
    _id;   //Event id 
    _exitCallback;

    _additionalCostHash =  window.crypto.randomUUID();

    _currentDatabase = Global.getLastDatabase();

    _barcodeInput;
    _clearTimer;

    _fieldInClipboard = null;
    _fieldEditor = React.createRef();

    _SIGNUP_SETTINGS_TAB = 0;
    _PATRON_LIST_TAB = 1;
    _CHECKIN_TAB = 2;
    _JOURNAL_TAB = 3;
    
    constructor(props) {
        super(props);
    
        this._id = props.id; 
        this._exitCallback = props.exitCallback;
        this.state.selectedTab = this._SIGNUP_SETTINGS_TAB;
    
        this.state.event = null;  //Event object

        this.state.signupEnabled = false;
        this.state.opensMinutesBeforeEnabled = false;
        this.state.closesMinutesBeforeEnabled = false;
        this.state.opensMinutesBefore = 1;
        this.state.closesMinutesBefore = 1;

        this.state.addingNewPatron = false;
        this.state.patronToEdit = null;
        this.state.editPatronPopoverOpen = false;
        this.state.refundPopupOpen = false;

        this.state.patronToViewQuestions = null;
        this.state.viewPatronQuestionsOpen = false;

        this.state.maxRefund = 0;
        this.state.refundPatron = null;

        this.state.recurrenceSignupQuestionOpen = false;
        this.state.signInSheetOpen = false;

        this.state.barcodeFieldValue = "";
        this.state.checkInStatusField = null;

        this.state.fieldToEdit = null;
    }


    componentDidMount() {
        super.componentDidMount(); 
        
        if (!this.state.event)  //fetch if not set
            this._fetchEvent(); 
        
        // Browser back button - go back to SlotsListPage
        window.addEventListener("popstate", this._popstateCallback);
        window.addEventListener("databaseChangeEvent", this._databaseChanged);
    }
   
    componentWillUnmount() {
        super.componentWillUnmount();       
        window.removeEventListener("popstate", this._popstateCallback);
        window.removeEventListener("databaseChangeEvent", this._databaseChanged);
    }
    
    _popstateCallback = (e) => {
        this._exitCallback();
    }

    _databaseChanged = () => {
        // Just close if the database changed
        if (Global.getLastDatabase() !== this._currentDatabase)
            this._exitCallback();
    }

    _discard = () => {
        this._exitCallback();
    }

    _editOnCalendar = () => {
        this.props.viewSlotInCalendarCallback(this.state.event, true);
    }

    _getPatronLink = () => {
        return "patron/event?database=" + this._currentDatabase + "&eventid=" + this.state.event.id;
    }

    _gotoEventSignup = () => {
        OpenInNewTab(this._getPatronLink());
    }

    _openQr = () => {
        const link = "https://" + window.location.host + "/" + this._getPatronLink();
        OpenQRPopupWindow(this.state.event.title, link);
    }

    _gotoMaster = () => {
        const masterId = this.state.event.masterEventId;
        this._id = masterId;
        this.setState({selectedTab: this._SIGNUP_SETTINGS_TAB});
        this._fetchEvent();
    }

    // From a new event, setup the signup settings from the event object's Signup object
    _setupFromEventSignup = (event, newSignupSettings = null) => {
        const signup = newSignupSettings ? newSignupSettings : event.signup;
        if (!signup.fieldTree)
            signup.fieldTree = {type: "FieldGroup", name: "BaseFieldGroup", isBase: true, children: []};

        event.signup = signup.copy();
    
        this.setState({event: event, 
            signupEnabled: signup.patronSignupEnabled,
            opensMinutesBeforeEnabled: signup.opensMinutesBefore ? true : false, 
            closesMinutesBeforeEnabled: signup.closesMinutesBefore ? true : false,
            opensMinutesBefore: signup.opensMinutesBefore ? signup.opensMinutesBefore : 1,
            closesMinutesBefore: signup.closesMinutesBefore ? signup.closesMinutesBefore : 1})
    }
    
    _fetchEvent = () => {
        this.setState({event: null, fieldToEdit: null});  // clear, to force re-render of all ManagedFields
        this.incrementBusy();
        this.secureJSONFetch("/bk/slots/" + this._id, {}, this._fetchEventCallback, this._fetchErrorCallback); 
    }
   
    _fetchEventCallback = (response) => {
        this.decrementBusy();
        if (response) {            
            const event = Constructors.slotFromJson(response, Global.getTimezone());

            if (event instanceof MultiDayEvent && !event.isMaster())
                this.setState({selectedTab: this._CHECKIN_TAB});  // slaves should start on this tab

            if (!event.signup) {
                const resourceId = event.resourceIds[0];        // must have at least one resource
                this.incrementBusy();
                this.secureJSONFetch("/bk/resources/" + resourceId, {}, (response) => this._fetchResourceCallback(response, event), this._fetchErrorCallback); 
            }
            else            
                this._setupFromEventSignup(event);
        }           
    }

    _fetchResourceCallback = (response, event) => { 
        this.decrementBusy();
        if (response) {
            const resource = new Resource(response);
            event.signup = Signup.initNew(resource.isoCurrency);
            this.setState({event: event});      // already have the signup data
        }
    }
    

    _downloadPatronList = () => {
        const filename = this.state.event.title + " Patron Export on " + DateUtils.downloadTimeString() + ".csv";
        this.secureFileDownload("/bk/slots/" + this.state.event.id + "/eventPatron/export", filename, null, (error) => this.showConfirmAlert("Error", error, 'red')); 
    }

    _fetchErrorCallback = (error) => {
        this.showConfirmAlert("Error", error, 'red');
        this.decrementBusy();
    }

    //A field in the Event signup was changed, update the selected Event object with the new data
    _signupFieldChanged = (fieldName, userValue) => {
        this.state.event.signup[fieldName] = userValue;  
    }


    _addOptionalCostItem = () => {
        const oc = OptionalCost.initNew();  
        this.state.event.signup.optionalCosts.push(oc);
        this.forceUpdate();
    }

    _optionalCostItem = (item, index) => {

        const signup = this.state.event.signup;

        const onFieldChange = (json, val) => {
            if (json === "name")
                item.name = val;
            else if (json === "maxQuantity")
                item.maxQuantity = parseInt(val);
            else if (json === "cost")
                item.cost = parseFloat(val);
            else
                console.log("Error: Unknown field name " + json);
            this.forceUpdate();
        };

        const removeItem = () => {
            signup.optionalCosts.splice(index, 1);
            this._additionalCostHash =  window.crypto.randomUUID();  // force a new hash
            this.forceUpdate();
        }

        // Hash is needed so React will re-render the list when an item is removed, since these are ManagedFields we want to destroy them and recreate them

        return (
            <div key={index + this._additionalCostHash} style={{display: 'flex', alignItems: 'center', justifyContent: 'left', gap: 10, marginTop: 10, marginBottom: 5}}>
                
                <ManageTextField label="Item Name"
                                initialValue={item.name}
                                json="name"  
                                tooltip="Name for the item the Patron may purchase"
                                autoAccept={true}
                                onFieldChange={onFieldChange}/>

                <div style={{minWidth: 230}}>
                    <ManageDecimalField fullWidth={false} hasInfinity={false} justify='left' 
                                    label={"Cost (" + signup.isoCurrency + ")"} minValue={0}
                                    decimalPlaces={2}
                                    autoAccept={true}
                                    json="cost"
                                    commitTimeout={10}
                                    initialValue={item.cost}
                                    onFieldChange={onFieldChange}
                                    changedBackgroundColor='white'/> 
                </div>

                <div style={{minWidth: 210}}>
                    <ManageNumericField fullWidth={false} hasInfinity={false} justify='left' 
                                    tooltip={"Maximum number of this item that can be purchased"}
                                    label="Max Quantity" minValue={1}
                                    json="maxQuantity"
                                    autoAccept={true}
                                    commitTimeout={10}
                                    initialValue={item.maxQuantity}
                                    onFieldChange={onFieldChange}
                                    changedBackgroundColor='white'/> 
                </div>

                <div style={{display: 'flex', alignItems: 'center'}}>
                    <Tooltip title={"When checked, the this item is a patron type. The quantity of all patron types must the total number number of patrons chosen to attend"}>
                        <Checkbox checked={item.addsToPatronCount} color='primary'
                                onChange={(event) => { item.addsToPatronCount = event.target.checked; this.forceUpdate();}}/>                  
                    </Tooltip>
                    <Typography variant='body2' align='left'>Patron Count</Typography>
                </div>
                
                <Tooltip title="Remove Item">
                    <IconButton onClick={removeItem} >
                        <ClearOutlinedIcon fontSize="large" style={{color: ThemeColors.darkRed}}/>
                    </IconButton>
                 </Tooltip>
            </div>
        );
    }


    _copySettings = () => {

        const copy = this.state.event.signup.copy();

        // Update those that are held in state
        if (this.state.opensMinutesBeforeEnabled) 
            copy.opensMinutesBefore = this.state.opensMinutesBefore;
        else       
            copy.opensMinutesBefore = null;

        if (this.state.closesMinutesBeforeEnabled)
            copy.closesMinutesBefore = this.state.closesMinutesBefore;
        else
            copy.closesMinutesBefore = null;  


        Global.copiedEventSettings = copy;
    }


    _pasteSettings = () => {
        if (!Global.copiedEventSettings) {
            this.showConfirmAlert("Error", "No settings copied from another Event.", 'red');
            return;
        }
        const event = this.state.event;
        this.setState({event: null});  // clear, to force re-render

        setTimeout(() => this._setupFromEventSignup(event, Global.copiedEventSettings));
    }

    _save = () => {

        if (this.state.event.isRecurring() && !(this.state.event instanceof MultiDayEvent))
            this.setState({recurrenceSignupQuestionOpen: true});
        else
            this._proceedWithSaveSignup(false);
    }

    _proceedWithSaveSignup = (allFuture) => {

        this.setState({recurrenceSignupQuestionOpen: false});

        if (this.state.opensMinutesBeforeEnabled) 
            this.state.event.signup.opensMinutesBefore = this.state.opensMinutesBefore;
        else       
            this.state.event.signup.opensMinutesBefore = null;

        if (this.state.closesMinutesBeforeEnabled)
            this.state.event.signup.closesMinutesBefore = this.state.closesMinutesBefore;
        else
            this.state.event.signup.closesMinutesBefore = null;    

        const recurQuery = allFuture ? "?allFutureRecurrences=true" : "";

        this.incrementBusy();
        this.secureJSONFetch("/bk/slots/" + this.state.event.id + "/upsertSignup" + recurQuery, {method: 'POST', body: this.state.event.signup.toJsonForPost()}, 
                             this._saveCallback, this._fetchErrorCallback);
    }

    _saveCallback = (response) => {
        this.decrementBusy();

        let internalMsg = "";
        if (this.state.event.visibility === CalEvent.Visibility.INTERNAL.enumName && this.state.event.signup.patronSignupEnabled)
            internalMsg = " Note: This Event is set to Internal visibility. Patrons will not be able to sign up for this Event until the visibility is changed to Public or Private Link.";

        this.showConfirmAlert("Success", "The Event signup has been updated." + internalMsg, 'green', "OK");
        this._fetchEvent();  // re-fetch to get any changes made on the server
    }

  
    // Refreshes the journal and signups for the Event, but not the signup settings
    _refresh = () => {   
        this.incrementBusy();
        this.secureJSONFetch("/bk/slots/" + this.state.event.id, {}, this._refreshCallback, this._fetchErrorCallback); 
    }

    _refreshCallback = (response) => {
        this.decrementBusy();
        if (response) {
            const refreshedEvent = Constructors.slotFromJson(response, Global.getTimezone());

            // Were only refreshing the journal and signups here, not the signup settings which may be being edited by the user
            const event = this.state.event.copy();
            event.refreshSignupsAndJournalFrom(refreshedEvent);

            this.setState({event: event});
            setTimeout(this._focusBarcodeField);
        }
    }


    _addPatron = () => {
        const patron = new Patron();
        this.setState({editPatronPopoverOpen: true, patronToEdit: patron, addingNewPatron: true});
    }

    _editPatron = (patron) => {
        this.setState({editPatronPopoverOpen: true, patronToEdit: patron, addingNewPatron: false});
    }

    _viewPatronQuestions = (patron) => {
        this.setState({viewPatronQuestionsOpen: true, patronToViewQuestions: patron});
    }

    _patronEdited = (contactName, email, phone, enableSms, patronNames) => {

        this.setState({editPatronPopoverOpen: false});

        const patron = this.state.patronToEdit;
        patron.contactName = contactName;
        patron.patronEmail = email;
        patron.patronPhone = phone;
        patron.enableSms = enableSms;
        patron.patronNames = patronNames;
        patron.patronCount = patronNames.length;

        // Sanity check, we can't add a patron to patronSignups
        if (this.state.addingNewPatron && !patron.isManual()) {
            console.log("Error: Attempt to add a new Patron to patronSignups");
            return;
        }
        const body = JSON.stringify(patron);

        this.incrementBusy();
        this.secureJSONFetch("/bk/slots/" + this.state.event.id + "/eventPatron?manual=" + patron.isManual(), {method: 'POST', body: body}, 
                             this._patronEditCallback, this._fetchErrorCallback);

    }

    _patronEditCallback = (response) => {
        this.decrementBusy();
        this.setState({patronToEdit: null, addingNewPatron: false});
        this._refresh();     // will force a re-render
    }

    _refundPatron = (patron) => {
        this.setState({refundPopupOpen: true, maxRefund: patron.calculatedCost - patron.refundedAmount, refundPatron: patron});
    }

    _startRefund = (amount, comment) => {
        this.setState({refundPopupOpen: false});

        const slotId = this.state.event.id;
        const patronId = this.state.refundPatron.id;
        const body = {amount: amount, comment: comment};
        this.incrementBusy();
        this.secureJSONFetch("/bk/slots/" + slotId + "/eventPatron/" + patronId + "/refund", {method: 'POST', body: JSON.stringify(body)}, 
                              this._refreshAfterRequest, this._fetchErrorCallback);
    }

    _refreshAfterRequest = () => {
        this.decrementBusy();
        this._refresh();
    }


    _deletePatron = (patron) => {

        if (!patron.isManual()) {
            console.log("Error: Attempt to delete a Patron that is not a manual signup");
            return;
        }

        this.showConfirmAlert("Delete Patron", "Are you sure you want to delete the manually added Patron \"" + patron.patronNames[0] + "\"?", 'red', 
                              "No",  () => this._doDeletePatron(patron), "Yes, Delete", 'red');

    }

    _doDeletePatron = (patron) => {

        this.incrementBusy();
        this.secureJSONFetch("/bk/slots/" + this.state.event.id + "/eventPatron/" + patron.id, {method: 'DELETE'},
                            (response) => {this._deletePatronCallback(patron)}, this._fetchErrorCallback);
    }

    _deletePatronCallback = (patron) => {
        this.decrementBusy();
        this._refresh();     // will force a re-render
    }


    _cancelPatronSignup = (patron) => {

        if (patron.isManual() || patron.cancelled)
            console.log("Error: Attempt to cancel a Patron that is already cancelled or not a manual signup");

        let refundMsg = "";
        if (patron.refundable() && this.state.event.signup.autoRefund)
            refundMsg = " You must issue refunds manually for this Patron.";


        this.showConfirmAlert("Cancel Signup", "Are you sure you want to cancel the signup for \"" + patron.patronNames[0] + "\"?" + refundMsg, 'red', 
                             "No",  () => this._doCancelPatronSignup(patron), "Yes, Cancel Signup", 'red');
    }

    _doCancelPatronSignup = (patron) => {

        this.incrementBusy();
        this.secureJSONFetch("/bk/slots/" + this.state.event.id + "/eventPatron/" + patron.id + "/cancel", {method: 'POST'},
                            (response) => {this._cancelPatronSignupCallback(patron)}, this._fetchErrorCallback);
    }

    _cancelPatronSignupCallback = (patron) => {
        this.decrementBusy();
        this._refresh();     // will force a re-render
    }


    _markCashPayment = (patron, paid) => {
        this.incrementBusy();
        this.secureJSONFetch("/bk/slots/" + this.state.event.id + "/eventPatron/" + patron.id + "/markCashPayment?paid=" + paid, 
                              {method: 'POST'}, 
                              this._refreshAfterRequest, this._fetchErrorCallback);
    }


    _changeMinutesPriorValue = (fieldName, increment) => {
        let newValue = this.state[fieldName] = this.state[fieldName] + increment;
        if (newValue < 1)
            newValue = 1;

        this.setState({ [fieldName]: newValue });
    }


    _showSignInWindow = () => {
        
        if (this.state.signInSheetOpen) {
            this.showConfirmAlert("Already Open", "A sign-in sheet is already open in another browser window", 'red');
            return; 
        }
        
        this.setState({signInSheetOpen: true});
    }

    _copyPatronEmailAddresses = () => {
        const emailAddresses = this.state.event.patronSignups.map(p => p.patronEmail).filter(email => email && email.length > 0);
        const manualEmails = this.state.event.manualSignups.map(p => p.patronEmail).filter(email => email && email.length > 0);
        emailAddresses.push(...manualEmails);

        if (emailAddresses.length === 0) {
            this.showConfirmAlert("No Emails", "There are no patron email addresses to copy", 'red');
            return;
        }

        const emailString = emailAddresses.join("; ");
        navigator.clipboard.writeText(emailString).then(() => {
            this.showConfirmAlert("Copied", emailAddresses.length + " email address" + (emailAddresses.length > 1 ? "es" : "") + " copied to clipboard", 'green');
        }, (err) => {
            this.showConfirmAlert("Error", "Failed to copy email addresses to clipboard: " + err, 'red');
        });
    }


    _plusMinusButtons = (fieldName, label, increment) => {


        const buttonStyle = {
            border: '1px solid #ccc',
            borderRadius: '0px',
            padding: '0px'
        };


        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0}}>
                <Typography variant='caption'>{label}</Typography>
                <IconButton size='small' style={buttonStyle} onClick={() => this._changeMinutesPriorValue(fieldName, increment)}>
                    <AddIcon />
                </IconButton>
                <IconButton size='small' style={buttonStyle} onClick={() => this._changeMinutesPriorValue(fieldName, -increment)}>
                    <RemoveIcon />
                </IconButton>
            </div>
        );
    }

    _minutesPriorComponent = (fieldPrefix) => {

        const fieldTitle = String(fieldPrefix).charAt(0).toUpperCase() + String(fieldPrefix).slice(1);
        
        const enabledName = fieldPrefix + "MinutesBeforeEnabled";
        const minutesPriorName = fieldPrefix + "MinutesBefore";

        const enabled = this.state[enabledName];
        const minutesPrior = this.state[minutesPriorName];

        const relativeTime = DateUtils.relativeTimeFormat(minutesPrior);
        const absoluteTime = this.state.event.start.minus({minutes: minutesPrior});

        return (
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 30, marginTop: 40, marginBottom: 50, height: 50}}>
                
                <div style={{display: 'flex', alignItems: 'center', width: 160}}>
                    <Tooltip title={"When checked, the Event " + fieldPrefix + " for signup this amount of time before it starts. Otherwise, Patrons can sign up until the Event starts."}>
                        <Checkbox checked={enabled} color='primary'
                                onChange={(event) => {this.setState({[enabledName]: event.target.checked});}}/>                       
                    </Tooltip>
                    <Typography variant='body1' align='left'>{"Signup " + fieldTitle}</Typography>
                </div>
                <div style={{display: enabled ? 'flex' : 'none', alignItems: 'center', justifyContent: 'start', gap: 5}}>
                    {this._plusMinusButtons(minutesPriorName, "WEEK", 60*24*7)}
                    {this._plusMinusButtons(minutesPriorName, "DAY", 60*24)}
                    {this._plusMinusButtons(minutesPriorName, "HR", 60)}
                    {this._plusMinusButtons(minutesPriorName, "MIN", 1)}
                </div>
                <div style={{display: enabled ? 'block' : 'none'}}>
                    <Typography variant='body2'>{relativeTime + " prior to Event start"}</Typography>                        
                    <Typography variant='body2'>{DateConversions.dateTimeStr(absoluteTime)}</Typography>   
                </div>
            </div>);
    }


    _doCheckIn = () => {
        const patronID = this.state.barcodeFieldValue.trim();
        console.log("Checking in Patron with ID: " + patronID);
        if (this._barcodeInput)
            this._barcodeInput.select();

        this._resetTimer();
        if (patronID.length === 0)
            return;
        this.incrementBusy();
        this.secureJSONFetch("/bk/slots/" + this.state.event.id + "/eventPatron/" + patronID + "/checkin", {method: 'POST'}, 
                             this._checkInCallback, this._checkInErrorCallback);
    }

    _checkInCallback = (response) => {
        if (response) {
            this.decrementBusy();
            const patron = new Patron(response);
        
            this.setState({checkInStatusField: {text: "✓  Checked In Patron under Signup for \"" + patron.patronNames[0] + "\"", color: 'green'}});   
            AudioPlay.playAcceptAudio();
            this._resetTimer();
            this._refresh();     // will force a re-render
        }
        else
            this._checkInErrorCallback("No Patron returned from server");
    }

    _checkInErrorCallback = (error) => {
        this.decrementBusy();
        this.setState({checkInStatusField: {text: "❌  " + error, color: 'red'}}); 
        AudioPlay.playDenyAudio();  
        this._resetTimer();
    }


    _barcodeKeyDown = (event) => {
        if (event.key === 'Enter')
            this._doCheckIn();
    }

    _clearBarcode = () => {
       this._stopTimer();
       this.setState({barcodeFieldValue: "", checkInStatusField: null});    //blank
       this._focusBarcodeField();
    }

    //Stop and clear any existing timer
    _stopTimer = () => {
        if (this._clearTimer) {
            clearTimeout(this._clearTimer);  //stop any existing timer
            this._clearTimer = null;
        }
    }
    
    //Start or reset the existing timer, calling the "_clearBarcode" function on timeout
    _resetTimer = () => {        
        this._stopTimer();
        this._clearTimer = setTimeout(this._clearBarcode, 10000);
    }

    _focusBarcodeField = () => {
        if (this._barcodeInput)
            this._barcodeInput.focus();
    }

    _selectPatronForCheckin = (patron) => {
        if (!patron)
            return;
        
        this.setState({barcodeFieldValue: patron.id});
        setTimeout(this._doCheckIn);
    }

    _subtractPatronCheckIn = (patron) => {
        if (!patron)
            return;
        
        this._clearBarcode();
        this.incrementBusy();
        this.secureJSONFetch("/bk/slots/" + this.state.event.id + "/eventPatron/" + patron.id + "/unCheckIn", {method: 'POST'}, 
                             this._unCheckInSuccess, this._fetchErrorCallback);
    }

    _unCheckInSuccess = (response) => {
        this.decrementBusy();
        this.showConfirmAlert("Success", "Patron check-in has been removed.", 'green', "OK", null, null, null, null, this._refresh);
    }


    _newTabSelected = (event, newValue) => {
        this.setState({selectedTab: newValue});
        if (newValue === this._CHECKIN_TAB) {
            // Check-in tab, focus the barcode field
            setTimeout(() => this._focusBarcodeField());
        }
    }

    _isEditorOpen = () => {
        return this.state.fieldToEdit != null;
    }

    _fieldPropertyEdit = (field) => {
        
        //When first created the FieldEditor component receives the field prop, however since it makes use of uncontrolled components, if the field is changed
        //we must call the fieldPropertyEdit() on its reference to update the field explicity.
        if (this._fieldEditor.current)
            this._fieldEditor.current.fieldPropertyEdit(field);

        console.log("Editing properties for field: " + field.name);
        this.setState({fieldToEdit: field});        
    }

    
    _insertFieldFromClipboard = (parent) => {
        
        if (!this._fieldInClipboard)
            return;  //nothing on clipboard
        
        const insertedField = FormTemplate.insertField(this.state.event.signup.fieldTree, parent, this._fieldInClipboard);
        
        if (this._isEditorOpen())
            this._fieldPropertyEdit(insertedField); //start editing the newly inserted field

        this.forceUpdate();
    }

    _fieldsAdded = (fields) => {
        if (fields.length > 0)
            this._fieldPropertyEdit(fields[0]); //start editing the first newly inserted field
    }
    
    _copyField = (field) => {
        this._fieldInClipboard = FormTemplate.copyField(field);
        console.log(this._fieldInClipboard.name + " is now on the Clipboard");
        this.forceUpdate();
    }

    _fieldMoved = (field) => {
        if (this._isEditorOpen())
            this._fieldPropertyEdit(field); //re-edit the field being moved
    }


    //Remove the field from the tree and place on Clipboard
    _cutField = (field) => {
        
        if (this.state.fieldToEdit && this.state.fieldToEdit.name === field.name) {
            this.setState({fieldToEdit: null});  //field is being deleted, stop editing it
        }
        
        const removedField = FormTemplate.removeField(this.state.event.signup.fieldTree, field);

        if (removedField) {
            this._fieldInClipboard = removedField;  //place on clipboard
            console.log(this._fieldInClipboard.name + " is now on the Clipboard");
            this.forceUpdate();
        }
        else {
            console.warn("Field \"" + field.name + "\" not found in Template, cannot remove");
        }
    }

    _removeField = (field) => {
        
        if (this.state.fieldToEdit && this.state.fieldToEdit.name === field.name) {
            this.setState({fieldToEdit: null});  //field is being deleted, stop editing it
        }
        
        FormTemplate.removeField(this.state.event.signup.fieldTree, field);
        this.forceUpdate();
    }
    
    
     //Edit the value of a field
    _formFieldValueChanged = (field, newValue) => {
        console.log("Field \"" + field.name + "\" changing to " + newValue);
        this.forceUpdate();
    } 

    //Called when editing the field value, and an error occurs
    _fieldInputError = (field, error) => {
        this.showConfirmAlert("Error for Field \"" + field + "\"", error, 'red');
    }

    //This function must return an array of available fields, each item in the array having a label, icon, and a callback function.  The callback function should
    //(a) create a new field and (b) call the insertFunction to insert it into the Template 
    _getAvailableFields = (insertFunc) => {
        const event = this.state.event;
        if (!event)
            return [];
        return Patron.getAvailableFields(event.signup.fieldTree, insertFunc, event.isoCurrency);        
    }



    render() {

        const buttonStyle = (activeColor, disabled) => {     
            let color = disabled ? 'lightGray' : activeColor;
            return {borderColor: color, color: color, textAlign: 'center'};
        };

        const event = this.state.event;
        const signup = event ? event.signup : null;

        if (!signup)
            return null;

        let controlsSignups = true;
        if (event instanceof MultiDayEvent && !event.isMaster())
            controlsSignups = false;  //only master event controls signups for a MultiDayEvent

        const canEdit = event.canEdit();
        const eventCancelled = event.state === "PENDING_CANCEL" || event.state === "CANCELLED";

        const dateDisplay = CommonPatronFunctions.finalBookingSignupDateDisplay(event, true);        

        let signupWindow = "";
        let signupColor = 'black';

        const now = DateConversions.now(Global.getTimezone()).set({second: 0, millisecond: 0});    

        let signupStartDate;
        if (this.state.opensMinutesBeforeEnabled)
            signupStartDate = event.start.minus({minutes: this.state.opensMinutesBefore});
        else
            signupStartDate = now;    // can sign up immediately

        // end of signup is when event starts, less the minutes before, if any
        const signupEndDate = event.start.minus({minutes: this.state.closesMinutesBeforeEnabled ? this.state.closesMinutesBefore : 0});

        if (now >= event.end)
            signupWindow = "Signup Window: Event is in the past";
        else if (now > signupEndDate)
            signupWindow = "Signup Window: Signup window has closed";
        else if (signupStartDate >= signupEndDate) {
            signupWindow = "Signup Window: Open time is on or after the close time!";
            signupColor = 'red';
        }
        else {
            const duration = DateConversions.duration(signupStartDate, signupEndDate);
            signupWindow = "Signup Window: " + DateUtils.relativeTimeFriendlyFormat(duration/60);
            signupColor = 'green';
        }
        
        const isNarrow = window.innerWidth < 800;


        const formRenderParams = {forPatron: false, 
                                  forTemplate: true, 
                                  canEdit: true, 
                                  showFieldNames: false,
                                  onChange: this._formFieldValueChanged, 
                                  cutField: this._cutField,
                                  copyField: this._copyField,
                                  removeField: this._removeField, 
                                  clipboardField: this._fieldInClipboard,
                                  insertFieldFromClipboard: this._insertFieldFromClipboard,
                                  getAvailableFields: this._getAvailableFields,
                                  onFieldPropertyEdit: this._fieldPropertyEdit,
                                  onFieldsAdded: this._fieldsAdded,
                                  fieldMoved: this._fieldMoved,
                                  fieldBeingEdited: this.state.fieldToEdit ? this.state.fieldToEdit.name : null,
                                  onError: this._fieldInputError};

        let tabs = [];
        if (controlsSignups) {
            tabs.push(<Tab value={this._SIGNUP_SETTINGS_TAB} style={{marginRight: isNarrow ? 0 : 20}} label={<div style={{ display: 'flex', alignItems: 'center' }}><AssignmentIcon fontSize="small" /><span style={{ marginLeft: 10 }}>{isNarrow ? "Settings" : "Signup Settings"}</span></div>} />,
                                <Tab value={this._PATRON_LIST_TAB} style={{marginRight: isNarrow ? 0 : 20}} label={<div style={{ display: 'flex', alignItems: 'center' }}><PeopleIcon fontSize="small" /><span style={{ marginLeft: 10 }}>Patrons</span></div>} />
            );
        }
        tabs.push(<Tab value={this._CHECKIN_TAB} style={{marginRight: isNarrow ? 0 : 20}} label={<div style={{ display: 'flex', alignItems: 'center' }}><CheckIcon fontSize="small" /><span style={{ marginLeft: 10 }}>Check-In</span></div>} />,
                            <Tab value={this._JOURNAL_TAB} label={<div style={{ display: 'flex', alignItems: 'center' }}><NotesIcon fontSize="small" /><span style={{ marginLeft: 10 }}>{isNarrow ? "Journal" : "Event Journal"}</span></div>} />
        );

        // For Events and MultiDayEvent Masters, the check-in list is all patrons signed up.  
        // For MultiDayEvent Slaves, we use the transient masterPatrons list which is the signed up patrons from the master, copied to this event
        let patronCheckInList = [];
        if (controlsSignups)
            patronCheckInList = [...event.patronSignups, ...event.manualSignups];
        else
            patronCheckInList = event.masterPatrons;  

        return (
            <Fragment>

                {this.getConfirmAlertComponent()}
                {this.state.isBusy ? this.getBusyComponent('right', {marginLeft: 20}, 30) : null}

                <RecurrenceSignupQuestionDialog isOpen={this.state.recurrenceSignupQuestionOpen} okSelected={this._proceedWithSaveSignup} 
                                                cancelSelected={() => this.setState({recurrenceSignupQuestionOpen: false})}/>

                <RefundPopover isOpen={this.state.refundPopupOpen} maxVal={this.state.maxRefund} currency={this.state.refundPatron ? this.state.refundPatron.isoCurrency : null}
                                okCallback={this._startRefund} cancelCallback={() => this.setState({refundPopupOpen: false})}/>                 
                           
                <PatronQuestionsViewer isOpen={this.state.viewPatronQuestionsOpen} patron={this.state.patronToViewQuestions}
                                       closeCallback={() => this.setState({viewPatronQuestionsOpen: false})}/>

                {this.state.editPatronPopoverOpen ?

                    <EditPatronPopover patron={this.state.patronToEdit}
                                        okCallback={this._patronEdited}
                                        cancelCallback={() => this.setState({editPatronPopoverOpen: false})}/>
                    : null
                }

                {this.state.signInSheetOpen ? 
                    <EventSigninSheet copyStyles={true} windowClosed={() => { this.setState({signInSheetOpen: false}); }} 
                                    windowBlocked={ () => { this.showConfirmAlert("Error", "Disable popup blockers", 'red'); }} 
                                    event={event}
                                    />
                    : null 
                }

                <div style={{display: 'flex', justifyContent: 'right', height: 30, gap: 10, marginBottom: 10}}>
                    {this.state.selectedTab > this._SIGNUP_SETTINGS_TAB ?
                        <IconButton edge="end" onClick={this._refresh} color='primary' style={{marginLeft: 0, marginRight: 1, marginBottom: 1}}>
                            <RefreshIcon/>
                        </IconButton>
                        : null
                    }
                    {controlsSignups ? 
                        <Fragment>
                            <Tooltip title="Get a QR Code image for the Patron signup Page">
                                <Button size='small' disabled={!event}  style={buttonStyle('black', !event)}  
                                        onClick={this._openQr} variant="outlined" component="label"
                                        startIcon={<img src={qrIcon} alt="QR Icon" style={{ width: 20, height: 20, paddingRight: 5 }}/>}>
                                    QR Code
                                </Button>
                            </Tooltip>
                            <Tooltip title="Go to the Page the Patron will visit to sign up for this Event (opens in new window)">
                                <Button size='small' disabled={!event}  style={buttonStyle('black', !event)}  
                                        onClick={this._gotoEventSignup} variant="outlined" component="label"
                                        startIcon={<ReplyIcon style={{transform: 'scaleX(-1)'}}/>}>
                                    Go to Patron Signup Page
                                </Button>
                            </Tooltip>
                        </Fragment>
                        :
                        <Tooltip title="Go to this page for the Master Event">
                            <Button size='small' disabled={!event}  style={buttonStyle('blue', !event)}  
                                    onClick={this._gotoMaster} variant="outlined" component="label">
                                Go to Master Event
                            </Button>
                        </Tooltip>
                    }
                    <Button disabled={!event}  size='small' 
                            style={buttonStyle('black', !event)} 
                            onClick={this._editOnCalendar} variant="outlined" component="label"
                            startIcon={<TodayIcon/>}>
                        Edit on Calendar Page
                    </Button>
                    <Tooltip title="Discard unsaved changes and close">
                        <Button disabled={!event}  size='small' 
                                style={buttonStyle('black', !event)} 
                                onClick={this._discard} variant="outlined" component="label">
                            Close
                        </Button>
                    </Tooltip>
                </div>
  
                <Tabs value={this.state.selectedTab} onChange={this._newTabSelected} indicatorColor="primary" textColor="primary" centered={true} variant='standard'>
                    {tabs}
                </Tabs>

                { /* -------------------------------------- Event Signup Tab -------------------------------------- */ }

                <Paper style={{display: this.state.selectedTab === this._SIGNUP_SETTINGS_TAB ? 'block' : 'none', ...this.styles.paper}}>   
    
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginRight: 20, gap: 20}}>
                        <div style={{...this.styles.paperLabel, flexGrow: 1}}>
                            <Typography variant="h6">{"Editing Signup Settings for \"" + event.title + "\" " + event.symbol() }</Typography> 
                            {dateDisplay} 
                        </div>
                        <Tooltip title="Copy settings to clipboard in order to apply them to another Event">
                            <Button size='small'
                                    onClick={this._copySettings} variant="outlined" component="label">
                                Copy Settings
                            </Button>
                        </Tooltip>
                        <Tooltip title="Paste previously copied settings, overwriting the current settings">
                            <Button size='small'
                                    onClick={this._pasteSettings} variant="outlined" component="label">
                                Paste Settings
                            </Button>
                        </Tooltip>
                        <Tooltip title="Save Changes and Refresh">
                            <Button disabled={!canEdit}  size='small' style={buttonStyle('green', !canEdit)} 
                                    onClick={this._save} variant="outlined" component="label">
                                Save Settings
                            </Button>
                        </Tooltip>                    
                    </div>
                    
    
                    <Grid container spacing={2}>

                        <Grid item xs={12} lg={5}>
                            
                            <Typography variant="body2" style={this.styles.sectionLabel}>Signups</Typography>            
                            <div style={this.styles.roundedContainer}>
                                
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginBottom: 10}}>
                                    <Tooltip title="When unchecked, Patrons cannot sign up for the Event (but you can manually add them)">
                                        <Checkbox defaultChecked={signup.patronSignupEnabled} color='primary'
                                                    onChange={(event) => { signup.patronSignupEnabled = event.target.checked; this.setState({signupEnabled: event.target.checked}); }}/>       
                                    </Tooltip>                           
                                    <Typography variant='body1' align='left' style={{color: this.state.signupEnabled ? 'green' : 'red', width: 200}}>Enable Patrons to Signup</Typography>                        
                                </div>
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginBottom: 10, height: 50}}>
                                    <Tooltip title="When checked, only Members can sign up for the Event (Members must supply a barcode or Membership ID when signing up and Membership must not be suspended or expired)">
                                        <Checkbox defaultChecked={signup.requiresMembership} color='primary'
                                                    onChange={(event) => signup.requiresMembership = event.target.checked}/> 
                                    </Tooltip>                                 
                                    <Typography variant='body1' align='left' style={{width: 200}}>Requires Membership</Typography>
                                </div>

                                <div style={{maxWidth: 300}}>
                                    <ManageNumericField fullWidth={false} hasInfinity={false} justify='left' 
                                                        tooltip="The maximum number of patrons that can sign up for this Event (you can manually add as many as you want)"
                                                        label="Max Patron Signups" minValue={1}
                                                        json="maxSignups"
                                                        autoAccept={true}
                                                        commitTimeout={10}
                                                        initialValue={signup.maxSignups} 
                                                        onFieldChange={this._signupFieldChanged} changedBackgroundColor='white'/>     
                                </div>

                                
                                {this._minutesPriorComponent("opens")}
                                {this._minutesPriorComponent("closes")}
                                
                                {this.state.closesMinutesBeforeEnabled ? null :
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginBottom: 10, height: 50}}>
                                        <Tooltip title="When checked, patrons may sign up late (after the Event has started)">
                                            <Checkbox defaultChecked={signup.allowLateSignups} color='primary'
                                                        onChange={(event) => signup.allowLateSignups = event.target.checked}/> 
                                        </Tooltip>                                 
                                        <Typography variant='body1' align='left' style={{width: 200}}>Allow Late Signups</Typography>
                                    </div>
                                }

                                <Typography variant='body1' style={{display: 'flex', justifyContent: 'center', color: signupColor, marginTop: 10, fontStyle: 'italic'}}>{signupWindow}</Typography>
                                <Typography variant='caption' style={{display: 'flex', justifyContent: 'center', fontStyle: 'italic', color: 'gray'}}>If the Event start time changes, the open and close signup times will shift relative to the new time.</Typography>                                               

                            </div>
                        </Grid>

                         <Grid item xs={12}>
                            <Typography variant="body2" style={this.styles.sectionLabel}>Signup Instructions</Typography>
                            <div style={{...this.styles.roundedContainer, paddingBottom: 10}}>
                                <RichTextEditor draftContent={signup.about}     
                                        editing={true}  
                                        onChange={ (draftJson) => {
                                            this._signupFieldChanged("about", draftJson);
                                        }}/>
                            </div>
                        </Grid>  

                        <Grid item xs={12} lg={7}>
                        
                            <Typography variant="body2" style={this.styles.sectionLabel}>Fees</Typography>
                            <div style={this.styles.roundedContainer}>

                                <Typography variant='caption' align='right' style={{display: 'flex', justifyContent: 'right', color: 'gray', fontStyle: 'italic', marginLeft: 'auto'}}>All costs are calculated and added to the total in the order below.</Typography>                        

                                <div style={{width: 340, marginBottom: 10}}>

                                    <ManageDecimalField fullWidth={false} hasInfinity={false} justify='left' 
                                                        label={"Cost per Patron (" + signup.isoCurrency + ")"} minValue={0}
                                                        decimalPlaces={2}
                                                        json="cost"
                                                        autoAccept={true}
                                                        commitTimeout={10}
                                                        initialValue={signup.cost} 
                                                        onFieldChange={this._signupFieldChanged} changedBackgroundColor='white'/>  
                                </div>   

                                {signup.optionalCosts.map((item, index) => this._optionalCostItem(item, index))}

                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20}}>
                                    <Button size='small' variant='outlined' style={{color: ThemeColors.addColor}} onClick={this._addOptionalCostItem} color='primary'>Add Cost Item</Button>
                                </div>

                                <div style={{display: 'flex', flexDirection: 'column', marginTop: 10, gap: 10, maxWidth: 300}}>

                                    <ManageDecimalField fullWidth={false} hasInfinity={false} justify='left' 
                                                        tooltip="Add a Service fee as a percentage to the total cost calculated above"
                                                        label={"Service Fee %"} minValue={0}
                                                        decimalPlaces={1}
                                                        commitTimeout={10}
                                                        autoAccept={true}
                                                        json="serviceFeePercent"
                                                        initialValue={signup.serviceFeePercent} 
                                                        onFieldChange={this._signupFieldChanged} changedBackgroundColor='white'/>  

                                    <ManageDecimalField fullWidth={false} hasInfinity={false} justify='left' 
                                                        tooltip="Add a fixed Service fee to the total cost calculated above"
                                                        label={"Fixed Service Fee (" + signup.isoCurrency + ")"}  minValue={0}
                                                        decimalPlaces={2}
                                                        autoAccept={true}
                                                        commitTimeout={10}
                                                        json="serviceFeeFixed"
                                                        initialValue={signup.serviceFeeFixed} 
                                                        onFieldChange={this._signupFieldChanged} changedBackgroundColor='white'/> 
                                </div>   

                                <div style={{display: 'flex', alignItems: 'center', marginLeft: 5, marginTop: 10, justifyContent: 'start'}}>
                                    <Tooltip title="Add an additional Service fee that matches your AGS payment processing fee, effectively passing our fee to you on to your Patrons. Only available if your Marketplace operates in USD.
                                                This fee is applied all other fees above. The fee is not applied if the order total is zero.">         
                        
                                        <Checkbox defaultChecked={signup.addAGSServiceFee} color='primary'
                                                    onChange={(event) => signup.addAGSServiceFee = event.target.checked}/>  
                                    </Tooltip>
                                    <Typography variant='body1' align='left'>Add Matching AGS Service Fee</Typography>                        
                                </div> 

                                <div style={{display: 'flex', alignItems: 'center', marginLeft: 5, marginTop: 10, justifyContent: 'start'}}>
                                    <Tooltip title="Allow patron to optionally pay with cash or other method outside of the Booking portal. The Event signup will indicate the amount due from the Patron.">
                        
                                        <Checkbox defaultChecked={signup.allowCashPayment} color='primary'
                                                    onChange={(event) => signup.allowCashPayment = event.target.checked}/>  
                                    </Tooltip>
                                    <Typography variant='body1' align='left'>Allow Other Payment</Typography>                        
                                    <Typography variant='caption' style={{marginLeft: 15, fontStyle: 'italic', color: 'gray'}} align='left'>If patron elects to pay a different way you must process this payment outside the portal. Indicate payment methods in your terms and conditions.</Typography>                                               
                                </div>  

                                

                            </div>
                        </Grid>

                        <Grid item xs={12} lg={5}>
                        
                            <Typography variant="body2" style={this.styles.sectionLabel}>Other Options</Typography>
                            <div style={this.styles.roundedContainer}>
                                
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                    <Tooltip title="When checked, if the patron cancels their signup, a refund is automatically issued. Otherwise, it must be manually issued.">
                                        <Checkbox defaultChecked={signup.autoRefund} color='primary'
                                                onChange={(event) => signup.autoRefund = event.target.checked}/>  
                                    </Tooltip>
                                    <Typography variant='body1' align='left'>Auto Refund Fee on Cancellation</Typography>                        
                                </div>  
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                    <Tooltip title="When checked, the Event owner is emailed when a Patron signs up or cancels">
                                        <Checkbox defaultChecked={signup.emailOnPatronSignup} color='primary'
                                                onChange={(event) => signup.emailOnPatronSignup = event.target.checked}/>  
                                    </Tooltip>
                                    <Typography variant='body1' align='left'>Email Event Owner on Signup Activity</Typography>                        
                                </div>  
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                    <Tooltip title="When checked, all Patron names are required. Otherwise, only the first name is required.">
                                        <Checkbox defaultChecked={signup.requireAllPatronNames} color='primary'
                                                onChange={(event) => signup.requireAllPatronNames = event.target.checked}/>  
                                    </Tooltip>      
                                    <Typography variant='body1' align='left'>Require all Patron Names</Typography>                        
                                </div> 
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                                    <Tooltip title="When checked, only the Event owner or users with full Booking portal permissions may check in patrons.">
                                        <Checkbox defaultChecked={signup.restrictCheckIn} color='primary'
                                                onChange={(event) => signup.restrictCheckIn = event.target.checked}/>  
                                    </Tooltip>      
                                    <Typography variant='body1' align='left'>Restrict Check-in to Event Owner Only</Typography>                        
                                </div> 
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                        
                            <Typography variant="body2" style={this.styles.sectionLabel}>Additional Patron Questions</Typography>
                            <div style={{...this.styles.roundedContainer, display: 'flex', minHeight: 500}}>
                                    
                                {signup.fieldTree.children.length === 0 ?
                                    <Typography variant='body1' align='right' style={{width: '100%', marginTop: 100, color: 'gray', fontStyle: 'italic'}}>
                                        Add patron questions using the + button
                                    </Typography>
                                    :
                                    null
                                }

                                <div style={{width: this.state.fieldToEdit !== null ? '70%' : '100%'}}>
                                    {signup.fieldTree ? renderField(signup.fieldTree, 0, formRenderParams) : null}
                                </div>
                                    
                                
                                <div style={{width: this.state.fieldToEdit !== null ? '30%' : '0%', marginLeft: 20}}>
                                    {this.state.fieldToEdit !== null ?
                                        <FieldEditor ref={this._fieldEditor} 
                                                     stayInContainer={true}
                                                     fieldToEdit={this.state.fieldToEdit}
                                                     fieldTree={signup.fieldTree}
                                                     hideFieldName={true}
                                                     hideSyncSelect={true}
                                                     hideHiddenSelect={true}
                                                     hideModifiableSelect={true}
                                                     hideDocumentMergeSelect={true}
                                                     hideUrlSettableSelect={true}
                                                     disableHiddenLogic={true}
                                                     hideWebhookSelect={true}
                                                     fieldWasEdited={() => this.forceUpdate()}
                                                     onClose ={() => this.setState({fieldToEdit: null})} />
                                        : 
                                        null
                                    }
                                </div>
                                       
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                        
                            <Typography variant="body2" style={this.styles.sectionLabel}>Terms & Conditions (patron must click checkbox to agree before signing up)</Typography>
                            <div style={{...this.styles.roundedContainer, paddingBottom: 10}}>

                                <RichTextEditor draftContent={signup.termsAndConditions}     
                                        editing={true}  
                                        onChange={ (draftJson) => {
                                            this._signupFieldChanged("termsAndConditions", draftJson);
                                        }}/>
                            </div>
                        </Grid>  

                    </Grid>
                </Paper>

                { /* -------------------------------------- Patrons Tab -------------------------------------- */ }

                <div style={{display: this.state.selectedTab === this._PATRON_LIST_TAB ? 'block' : 'none'}}>
                    <Paper style={this.styles.paper}>   
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginRight: 20}}>
                             <div style={{...this.styles.paperLabel, flexGrow: 1}}>
                                <Typography variant="h6">{"Patron Signups for \"" + event.title + "\" (" + event.patronSignupCount() + ")"}</Typography> 
                                {dateDisplay} 
                            </div>
                            <Typography style={this.styles.paperLabel} variant="h6">{"Spaces Left: " + event.spacesLeft()}</Typography> 
                        </div>
                        <PatronSignupTable event={event} eventCancelled={eventCancelled} patronList={event.patronSignups} editPatron={this._editPatron} 
                                           viewPatronQuestions={this._viewPatronQuestions} refundPatron={this._refundPatron} cancelPatronSignup={this._cancelPatronSignup}
                                           markCashPayment={this._markCashPayment}/>

                    </Paper>
                    <Paper style={this.styles.paper}>   
        
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginRight: 20}}>
                            <Typography style={this.styles.paperLabel} variant="h6">{"Manual Signup Entries for \"" + event.title + "\" (" + event.manualSignupCount() + ")"}</Typography> 
                            <Tooltip title="Add Patron Manually">
                                <Button disabled={!canEdit || eventCancelled}  size='small' style={buttonStyle('green', !canEdit || eventCancelled)} 
                                        onClick={this._addPatron} variant="outlined" component="label">
                                    Add Patron
                                </Button>
                            </Tooltip>       
                        </div>

                        <PatronSignupTable event={event} patronList={event.manualSignups} editPatron={this._editPatron} deletePatron={this._deletePatron}/>

                    </Paper>
                    <Paper style={this.styles.paper}>   
        
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginRight: 20, gap: 20}}>
                            <Typography style={this.styles.paperLabel} variant="h6">{"Cancelled Signups for \"" + event.title + "\" (" + event.cancelledSignupCount() + ")"}</Typography>
                        </div>
                        <PatronSignupTable event={event} refundPatron={this._refundPatron} patronList={event.cancelledSignups} markCashPayment={this._markCashPayment}/>

                    </Paper>

                    <div style={{display: 'flex', justifyContent: 'center', gap: 20, marginTop: 40}}>
                        <Button size='small' variant='outlined'  onClick={this._downloadPatronList} color='primary'>Download Patron List</Button>
                        <Button size='small' variant='outlined'  onClick={this._showSignInWindow} color='primary'>Print Sign-In Sheet</Button>
                        <Button size='small' variant='outlined'  onClick={this._copyPatronEmailAddresses} color='primary'>Copy Patron Email Addresses</Button>
                    </div>
                </div>

                { /* -------------------------------------- Check-in Tab -------------------------------------- */ }

                <div style={{display: this.state.selectedTab === this._CHECKIN_TAB ? 'block' : 'none'}}>
                    <Paper style={this.styles.paper}>   
                        <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginRight: 20}}>
                            <div style={{...this.styles.paperLabel, flexGrow: 1}}>
                                <Typography variant="h6">{"Check-In for \"" + event.title + "\""}</Typography> 
                                {dateDisplay} 
                            </div>
                            <Typography style={this.styles.checkedInLabel} variant="h6">{"Checked In: " + event.checkedInCount() + " / " + event.totalPatronCount()}</Typography> 
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', marginBottom: 20}}>
                            <TextField autoFocus inputRef={(field) => this._barcodeInput = field} value={this.state.barcodeFieldValue} onChange={(event) => this.setState({barcodeFieldValue: event.target.value})    }  
                                label="Check-In Patron" onKeyDown={this._barcodeKeyDown} variant="outlined" 
                                inputProps={{style: {fontSize: 20}}} fullWidth={true} InputLabelProps={{ shrink: true}} />
                            <Tooltip title="Clear">
                                <IconButton edge="end" onClick={this._clearBarcode} style={{marginLeft: 4}}>
                                    <CancelIcon fontSize='medium' />
                                </IconButton>
                            </Tooltip>
                        </div>
                        {this.state.checkInStatusField ?
                             <Typography align='center' variant='h5' style={{marginBottom: 20, color: this.state.checkInStatusField.color}}>{this.state.checkInStatusField.text}</Typography>
                             :           
                            <div style={{height: 32, marginBottom: 20}}></div>
                        }
                        <PatronCheckInTable patronList={patronCheckInList}
                                            selectPatronForCheckIn={this._selectPatronForCheckin}
                                            subtractPatronCheckIn={this._subtractPatronCheckIn}
                                            viewPatronQuestions={this._viewPatronQuestions}/>

                    </Paper>
                </div>

                { /* -------------------------------------- Journal Tab -------------------------------------- */ }

                <Paper style={{display: this.state.selectedTab === this._JOURNAL_TAB ? 'block' : 'none', ...this.styles.paper}}>   

                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginRight: 20, gap: 20}}>
                        <div style={{...this.styles.paperLabel, flexGrow: 1}}>
                            <Typography variant="h6">{"Journal for \"" + event.title + "\""}</Typography> 
                            {dateDisplay} 
                        </div>
                    </div>

                    <div style={{marginLeft: 30, marginRight: 30}}>
                        {event.renderJournal(true)}
                    </div>

                </Paper>

            </Fragment>
        );
    }

}


export default withCookies(withRouter(EventSignupPage));
